import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/config/languages';

const supportedCodes = SUPPORTED_LANGUAGES.map(l => l.code);

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: supportedCodes,
        debug: import.meta.env.DEV, // Enable debug in development

        interpolation: {
            escapeValue: false, // React already safe from XSS
        },

        backend: {
            loadPath: '/locales/{{lng}}/translation.json?v=4',
        },

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'], // Cache selected language in localStorage
        }
    });

export default i18n;
